export const FETCH_ONBOARDING_JOB_CODE_REQUEST = 'FETCH_ONBOARDING_JOB_CODE_REQUEST';
export const FETCH_ONBOARDING_JOB_CODE_SUCCESS = 'FETCH_ONBOARDING_JOB_CODE_SUCCESS';
export const FETCH_ONBOARDING_JOB_CODE_FAILURE = 'FETCH_ONBOARDING_JOB_CODE_FAILURE';

export const FETCH_ONBOARDING_IMPORT_LIST_REQUEST = 'FETCH_ONBOARDING_IMPORT_LIST_REQUEST';
export const FETCH_ONBOARDING_IMPORT_LIST_SUCCESS = 'FETCH_ONBOARDING_IMPORT_LIST_SUCCESS';
export const FETCH_ONBOARDING_IMPORT_LIST_FAILURE = 'FETCH_ONBOARDING_IMPORT_LIST_FAILURE';

export const SAVE_ONBOARDING_APPLY_JOB_REQUEST = 'SAVE_ONBOARDING_APPLY_JOB_REQUEST';
export const SAVE_ONBOARDING_APPLY_JOB_SUCCESS = 'SAVE_ONBOARDING_APPLY_JOB_SUCCESS';
export const SAVE_ONBOARDING_APPLY_JOB_FAILURE = 'SAVE_ONBOARDING_APPLY_JOB_FAILURE';

export const FETCH_IMPORT_TEMPLATE_REQUEST = 'FETCH_IMPORT_TEMPLATE_REQUEST';
export const FETCH_IMPORT_TEMPLATE_SUCCESS = 'FETCH_IMPORT_TEMPLATE_SUCCESS';
export const FETCH_IMPORT_TEMPLATE_FAILURE = 'FETCH_IMPORT_TEMPLATE_FAILURE';

export const UPLOAD_ONBOARDING_IMPORT_FILE_REQUEST = 'UPLOAD_ONBOARDING_IMPORT_FILE_REQUEST';
export const UPLOAD_ONBOARDING_IMPORT_FILE_SUCCESS = 'UPLOAD_ONBOARDING_IMPORT_FILE_SUCCESS';
export const UPLOAD_ONBOARDING_IMPORT_FILE_FAILURE = 'UPLOAD_ONBOARDING_IMPORT_FILE_FAILURE';

export const FETCH_ONBOARDING_JOB_APPROVE_LIST = "FETCH_ONBOARDING_JOB_APPROVE_LIST";
export const FETCH_ONBOARDING_JOB_APPROVE_LIST_SUCCESS = "FETCH_ONBOARDING_JOB_APPROVE_LIST_SUCCESS";
export const FETCH_ONBOARDING_JOB_APPROVE_LIST_FAILURE = "FETCH_ONBOARDING_JOB_APPROVE_LIST_FAILURE";

export const SAVE_ONBOARDING_JOB_APPROVE = "SAVE_ONBOARDING_JOB_APPROVE";
export const SAVE_ONBOARDING_JOB_APPROVE_SUCCESS = "SAVE_ONBOARDING_JOB_APPROVE_SUCCESS";
export const SAVE_ONBOARDING_JOB_APPROVE_FAILURE = "SAVE_ONBOARDING_JOB_APPROVE_FAILURE";

export const FETCH_ONBOARDING_DROPDOWN_LIST = 'FETCH_ONBOARDING_DROPDOWN_LIST';
export const FETCH_ONBOARDING_DROPDOWN_LIST_SUCCESS = 'FETCH_ONBOARDING_DROPDOWN_LIST_SUCCESS';
export const FETCH_ONBOARDING_DROPDOWN_LIST_FAILURE = 'FETCH_ONBOARDING_DROPDOWN_LIST_FAILURE';

export const FETCH_ONBOARDING_PROCESS_LIST = 'FETCH_ONBOARDING_PROCESS_LIST';
export const FETCH_ONBOARDING_PROCESS_LIST_SUCCESS = 'FETCH_ONBOARDING_PROCESS_LIST_SUCCESS';
export const FETCH_ONBOARDING_PROCESS_LIST_FAILURE = 'FETCH_ONBOARDING_PROCESS_LIST_FAILURE';

export const FETCH_ONBOARDING_PROCESS_ASSIGN_LIST = 'FETCH_ONBOARDING_PROCESS_ASSIGN_LIST';
export const FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_SUCCESS = 'FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_SUCCESS';
export const FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_FAILURE = 'FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_FAILURE';

export const CHANGE_ONBOARDING_PROCESS_STATUS = 'CHANGE_ONBOARDING_PROCESS_STATUS';
export const CHANGE_ONBOARDING_PROCESS_STATUS_SUCCESS = 'CHANGE_ONBOARDING_PROCESS_STATUS_SUCCESS';
export const CHANGE_ONBOARDING_PROCESS_STATUS_FAILURE = 'CHANGE_ONBOARDING_PROCESS_STATUS_FAILURE';

export const SAVE_ONBOARDING_SCHEDULING_PROCESS = 'SAVE_ONBOARDING_SCHEDULING_PROCESS';
export const SAVE_ONBOARDING_SCHEDULING_PROCESS_SUCCESS = 'SAVE_ONBOARDING_SCHEDULING_PROCESS_SUCCESS';
export const SAVE_ONBOARDING_SCHEDULING_PROCESS_FAILURE = 'SAVE_ONBOARDING_SCHEDULING_PROCESS_FAILURE';

export const UPDATE_APPLICANTS_LEVELS_REQUEST = 'UPDATE_APPLICANTS_LEVELS_REQUEST';
export const UPDATE_APPLICANTS_LEVELS_SUCCESS = 'UPDATE_APPLICANTS_LEVELS_SUCCESS';
export const UPDATE_APPLICANTS_LEVELS_FAILURE = 'UPDATE_APPLICANTS_LEVELS_FAILURE';

export const FETCH_APPLICANT_LEVEL_DTLS_REQUEST = 'FETCH_APPLICANT_LEVEL_DTLS_REQUEST';
export const FETCH_APPLICANT_LEVEL_DTLS_SUCCESS = 'FETCH_APPLICANT_LEVEL_DTLS_SUCCESS';
export const FETCH_APPLICANT_LEVEL_DTLS_FAILURE = 'FETCH_APPLICANT_LEVEL_DTLS_FAILURE';
